<template>
  <div class="base-layout-app">
    <template v-if="!loading">
      <BaseNavPrimary />
      <div class="container">
        <div class="contents">
          <slot />
        </div>
      </div>
    </template>
    <div class="loading" v-else>
      <BaseNavPrimary />
      <div class="spinner">
        <BaseSpinner size="2rem" />
      </div>
    </div>
  </div>
</template>

<script>
import BaseNavPrimary from '@/components/BaseNavPrimary/BaseNavPrimary'
import BaseSpinner from '@/components/BaseSpinner/BaseSpinner'
export default {
  components: {
    BaseNavPrimary,
    BaseSpinner
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: var(--spacing-5);
  margin-bottom: 10rem;
  @include media(sm-down) {
    padding: var(--spacing-5) var(--spacing-4);
  }
}
.contents {
  width: 100%;
  max-width: var(--width-1);
}
.loading {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.spinner {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
